import { useState, useEffect } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Calendar } from "primereact/calendar";
import { AutoComplete } from "primereact/autocomplete";
import moment from "moment-timezone";
import { CharacterLimit } from "../common/CharacterLimit/CharacterLimit";
import deleteIcon from "../../assets/images/deleteIcon.svg";
import CalendarIcon from "../common/CalendarIcon/CalendarIcon";
import ConfirmationDialogBox from "../ConfirmDialog/ConfirmationDialogBox";
import { deletePopupMessage } from "../../constants/DesignJobsConstant";
import { changeDateFormat } from "../../utils";
import { positiveNumberPattern, alphanumericPattern } from "../../constants/regex";

export default function Waves({
  index,
  waveDetails,
  checkReadWriteAccess,
  waves,
  setWaves,
  assigneeListOptions,
  handleDeleteJob,
  handleDelete,
  Project_Status,
  Wave_ID,
  waveDesignDisabled,
  setIsWaveNameError,
}) {

  const [filteredAssignees, setFilteredAssignees] = useState(null);
  const [visible, setVisible] = useState(false);
  const [buttonStatus, setButtonStatus] = useState("");
  const [EstStartDate, setEstStartDate] = useState(null);
  const [EstAWPrinterDate, setEstAWPrinterDate] = useState(null);
  const [waveNameError, setWaveNameError] = useState("");
  const [waveName, setWaveName] = useState("");
  const defaultWaveName = "Wave " + (index + 1);
  const textFieldMaxLength = 30;
  // keep local waveName in sync with incoming props so validation works
  useEffect(() => {
    setWaveName(waveDetails?.Wave_Name || "");
  }, [waveDetails?.Wave_Name]);

  let waveEmptyRowDisabled = !(Project_Status === "");

  const completeSearchAssignee = (event) => {
    // Timeout to emulate a network connection
    setTimeout(() => {
      let _filteredaAssignees;

      if (!event.query.trim().length) {
        _filteredaAssignees = [...assigneeListOptions];
      } else {
        _filteredaAssignees = assigneeListOptions.filter((objAssignee) => { 
          return objAssignee.Person
            .toLowerCase()
            .startsWith(event.query.toLowerCase());
        });
      }

      setFilteredAssignees(_filteredaAssignees);
    }, 250);
  };

  const handleDeleteButton = (index) => {
    handleDelete(index);
    /*if (Project_Status === "") {
      handleDelete(index);
    } else if (Project_Status === "Awaiting") {
      handleDeleteJob && handleDeleteJob(Wave_ID);
      handleDeleteJob && handleDelete(index);
    } else {
      setButtonStatus("Delete");
      setVisible(true);
    }*/
  };

  // validate wave name uniqueness whenever the name or list updates
  useEffect(() => {
    // trim and normalize current value for comparison
    const normalized = waveName?.trim().toLowerCase();

    if (normalized) {
      // look for another wave with the same name but a different index
      const duplicate = waves?.some((w, idx) => {
        return (
          idx !== index &&
          w?.Wave_Name?.trim().toLowerCase() === normalized
        );
      });

      if (duplicate) {
        setWaveNameError("Wave name must be unique");
        setIsWaveNameError(true);
      } else {
        setWaveNameError("");
        setIsWaveNameError(false);
      }
    } else {
      // empty name should not show the uniqueness error
      setWaveNameError("");
      setIsWaveNameError(false);
    }
  }, [waves, waveName, index]);

  const formatIntoDatePicker = (date) => { 
    const formattedDate = new Date(
      moment(date, "DD-MMM-YY")
        .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
        .format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)")
    );
    if (formattedDate.getFullYear() > "1999") {
      return formattedDate;
    } else {
      return "";
    }
  };

  const handleValueChange = (val, input_field_name) => {
    const tempWaveDetails = { ...waveDetails };
    switch (input_field_name) {
      case "Wave_Name":
        if (!alphanumericPattern.test(val)) {
          tempWaveDetails.Wave_Name = val;
        }
        break;
      case "Qty_Of_FA":
        if (positiveNumberPattern.test(val) || val === "") {
          tempWaveDetails.Qty_Of_FA = val;
        }
        break;
      case "T_POA_Owner":
        tempWaveDetails.T_POA_Owner = val;
        break;  
      case "Estimated_Start_Date":
        tempWaveDetails.Estimated_Start_Date = val;
        break;
      
      case "Est_AW_Printer_Date":
        tempWaveDetails.Est_AW_Printer_Date = val;
        break;
      default:
        break;
    }

    let tempAllWaves = [...waves];
    tempAllWaves.splice(index, 1, tempWaveDetails);
    setWaves(tempAllWaves);
  };

  const handleJobDelete = async () => {
    handleDeleteJob && handleDeleteJob(Wave_ID);
    handleDeleteJob && handleDelete(index);
    setVisible(false);
  };

  return (
    <div className="mb-4">
      <div className="fullkit-task-header">
        <span>
          {waveDetails?.Wave_Name || defaultWaveName}
        </span>
        <span>
          <img
            src={deleteIcon}
            alt="delete waves"
            onClick={() => checkReadWriteAccess && handleDeleteButton(index)}
            className="header-icons"
            disabled={!checkReadWriteAccess}
          />
        </span>
      </div>
      <Row className="fullkit-task-details">
        <Col>
          <Form.Group>
            <Form.Label>
              Wave Name <sup>*</sup>
            </Form.Label>
            <input
              id={`Wave_Name-${index}`}
              type="text"
              maxLength={textFieldMaxLength}
              className="form-control font-size-10 taskValueInput"
              onChange={(e) => {
                setWaveName(e.target.value);
                handleValueChange(e.target.value, "Wave_Name");
              }}
              value={waveDetails.Wave_Name}
              disabled={waveDesignDisabled && waveEmptyRowDisabled}
            />
            {(waveDetails.Wave_Name === "" || waveDetails.Wave_Name === undefined) && (
              <span className="error-text-di">Field Remaining</span>
            )}{" "}
            {waveNameError && (
              <span className="error-text-di">{waveNameError}</span>
            )}
            <CharacterLimit field={waveDetails.Wave_Name || defaultWaveName} maxLength={textFieldMaxLength} />
          </Form.Group>
        </Col>
        <Col>
          <div className="d-flex flex-column">
            <label htmlFor={`Qty_Of_FA-${index}`}>
              Quantity of PMPs/FAs <sup>*</sup>
            </label>
            <input
              id={`Qty_Of_FA-${index}`}
              type="text"
              maxLength={textFieldMaxLength}
              className="form-control font-size-10 taskValueInput"
              onChange={(e) => handleValueChange(e.target.value, "Qty_Of_FA")}
              value={waveDetails.Qty_Of_FA}
              disabled={waveDesignDisabled && waveEmptyRowDisabled}
            />
          </div>
        </Col>
        <Col>
          <Form.Group>
            <Form.Label>
              TPOA/POA Shell Creation Owner
            </Form.Label>
            <AutoComplete
              field="Person"
              disabled={waveDesignDisabled && waveEmptyRowDisabled}
              id={`T_POA_Owner-${index}`}
              value={waveDetails.T_POA_Owner}
              forceSelection
              suggestions={filteredAssignees}
              completeMethod={completeSearchAssignee}
              onChange={(e) => {
                handleValueChange(e.value, "T_POA_Owner");
              }}
              dropdown
            />
          </Form.Group>
        </Col>
        <Col>
          <Form.Group>
            <Form.Label>
              Wave Start Date
            </Form.Label>
            <Calendar
              id={`Estimated_Start_Date-${index}`}
              disabled={waveDesignDisabled && waveEmptyRowDisabled}
              minDate={new Date()}
              dateFormat="d-M-y"
              value={
                waveDetails?.Estimated_Start_Date
                  ? formatIntoDatePicker(changeDateFormat(waveDetails?.Estimated_Start_Date))
                  : EstStartDate
              }
              onChange={(e) => {
                setEstStartDate(e.value);
                handleValueChange(e.value, "Estimated_Start_Date");
              }}
              icon={<CalendarIcon />}
              showIcon={true}
            />
          </Form.Group>
        </Col>
        <Col>
          <Form.Group>
            <Form.Label>
              Estimated AW@Printer Date
            </Form.Label>
            <Calendar
              id={`Est_AW_Printer_Date-${index}`}
              disabled={waveDesignDisabled && waveEmptyRowDisabled}
              minDate={new Date()}
              dateFormat="d-M-y"
              value={
                waveDetails?.Est_AW_Printer_Date
                  ? formatIntoDatePicker(changeDateFormat(waveDetails?.Est_AW_Printer_Date))
                  : EstAWPrinterDate
              }
              onChange={(e) => {
                setEstAWPrinterDate(e.value);
                handleValueChange(e.value, "Est_AW_Printer_Date");
              }}
              icon={<CalendarIcon />}
              showIcon={true}
            />
          </Form.Group>
        </Col>
      </Row>
      {buttonStatus === "Delete" && visible && (
        <ConfirmationDialogBox
          visible={visible}
          onHide={setVisible}
          message={<>{deletePopupMessage}</>}
          icon="pi"
          handleContinue={() => {
            handleJobDelete();
          }}
          handleCancel={() => {
            setVisible(false);
          }}
        />
      )}
    </div>
  );
}
